import { ComponentChildren } from 'preact';
import { centerXYToPanXY } from './utils/panUtils';
import { panZoomStyles } from './themes/DiagramStyles.css';

type Props = {
  centerX: number;
  centerY: number;
  zoom: number;
  width: number;
  height: number;
  children: ComponentChildren;
};

export function DiagramPanZoomContainer({
  centerX,
  centerY,
  children,
  zoom,
  width,
  height
}: Props) {
  const panValues = centerXYToPanXY(centerX, centerY, zoom, width, height);
  return (
    <div
      class={panZoomStyles}
      style={{
        //TODO JET-62471 look at using matrices or both in transform instead
        translate: `${panValues.panX}px ${panValues.panY}px`,
        transform: `scale(${zoom})`
      }}>
      {children}
    </div>
  );
}
